export var Role;
(function (Role) {
    Role["VIEWER"] = "Viewer";
    Role["MANAGER"] = "Manager";
    Role["ADMIN"] = "Admin";
    Role["INSTALLER"] = "Installer";
})(Role || (Role = {}));
export const permissionsList = Object.keys(Role).map((key) => ({
    value: key,
    title: Role[key],
}));
